import React from "react";

function ArrowUpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="62"
      fill="none"
      viewBox="0 0 67 62"
    >
      <path
        fill="#000"
        d="M65.76 53.12c-7.888 1.684-16.05-.858-22.537-5.476-3.553-2.528-6.614-5.62-9.434-8.881-1.65-1.973-5.52-5.564-3.883-8.39 1.396-2.388 5.72-2.198 7.948-1.069 2.529 1.306 4.042 4.588 2.587 7.163-1.454 2.575-4.807 3.305-7.584 2.659-3.82-.933-7.292-3.785-10.235-6.184C14.81 26.66 8.506 18.904 2.254 11.184c-.508-.59-.188-1.615.612-1.692 2.848-.253 5.521.053 8.196.893-.224.626-.45 1.238-.679 1.835-1.808-.793-4.395-1.912-6.427-1.649-1.681.21-1.238 1.21-.97 2.502.223 1.122.463 2.256.72 3.402.231 1.342-1.926 1.669-2.157.326-.372-1.899-1.038-3.93-1.05-5.84C.467 9.988.7 9.242 1.609 8.75c1.21-.583 3.083-.2 4.39.047 1.77.31 3.446.856 5.063 1.589 1.175.533.563 2.225-.679 1.835-2.387-.75-4.722-.93-7.16-.65.234-.568.453-1.134.657-1.698 4.89 6.103 9.832 12.243 15.513 17.693 2.98 2.882 6.255 5.63 9.762 7.9 1.883 1.225 4.125 2.441 6.473 2.175 2.386-.317 4.45-2.23 3.475-4.748-.894-2.309-3.649-3.092-5.953-2.565-3.873.853-.193 4.65 1.022 6.2 2.526 3.128 5.301 6.13 8.501 8.712 6.444 5.157 14.594 8.412 22.9 6.8.66-.1.84.939.187 1.082z"
      ></path>
    </svg>
  );
}

export default ArrowUpIcon;
